import { actions, reducer } from './reducer';
import * as sagas from './sagas';
import * as selectors from './selectors';

export const shareAccessModel = { actions, reducer, selectors, sagas };
